<!-- 评论 -->
<template>
  <div class="comment-block">
    <div>
      <van-field
        v-model="pageConfig.content"
        rows="10"
        autosize
        label
        type="textarea"
        maxlength="200"
        placeholder="请输入评论（必填）"
        show-word-limit
      />
    </div>
    <div class="upload-block">
      <p>选择抄送人</p>
      <van-cell  is-link @click="pageConfig.ShowMultipleStaff = true">
        <template #title>
          <div class="personList" v-if="pageConfig.checkedStaffList.length < 4">
            <span v-for="(item,index) in pageConfig.checkedStaffList">{{item.emp_code + '-'+ item.emp_name}} <span v-if="index != 4 && index < pageConfig.checkedStaffList.length - 1">、</span></span>
          </div>
          <div class="personList" v-if="pageConfig.checkedStaffList.length > 4">
            <span>{{pageConfig.checkedStaffList[0].emp_code + '-'+ pageConfig.checkedStaffList[0].emp_name}}&nbsp;&nbsp;等{{pageConfig.checkedStaffList.length}}人</span>
          </div>
        </template>
      </van-cell>
      <div class="line"></div>
    </div>
    <div class="upload-block">
      <p>上传图片 png / jpg / gif</p>
      <div class="upload-photo">
        <van-uploader
          :after-read="methods.uploadFile"
          accept="image/png, image/jpeg, image/gif"
          v-model="pageConfig.photoList"
          :max-count="5"
        />
      </div>
      <p>上传附件</p>
      <div class="upload-file">
        <van-uploader
          :after-read="methods.uploadFile"
          multiple
          v-model="pageConfig.fileList"
          accept
          :max-count="3"
        />
      </div>
    </div>
    <div class="button-block">
      <van-button type="primary"   :loading="pageConfig.btnLoading" @click="methods.submitComment" size="large"
        >评论</van-button
      >
    </div>
    <MultipleStaff2
        v-if="pageConfig.ShowMultipleStaff"
        @saveMultipleStaff="methods.saveMustMultipleStaff"
        @closeMultipleStaff="pageConfig.ShowMultipleStaff = false"
        :showMultipleStaff="pageConfig.ShowMultipleStaff"
        :checkedStaffList="pageConfig.checkedStaffList"/>
  </div>
</template>
<script>
import { reactive } from '@vue/reactivity'
import { useRoute, useRouter } from 'vue-router'
import { AddComment,GetNewestFormto } from '@/api/oawfs.js' //
import { Toast } from 'vant'
import { onMounted } from '@vue/runtime-core'
import { UploadBase64 } from '@/api/oaApi.js'
import ChangeTitle from '@/utils/changeTitle.js'
import MultipleStaff2 from "../../../../components/MultipleStaff2.vue";


export default {
  components: {MultipleStaff2},
  props: ['instanceId'],
  setup (props, { emit }) {
    const route = useRoute()
    const pageConfig = reactive({
      formto_id: '',//评论的id   
      instanceId:props.instanceId??route.params.instance_id,//实例id
      content: "",//评论
      photoList: [],//图片列表
      fileList: [],//附件列表
      btnLoading:false,
      ShowMultipleStaff:false, // 显示员工选择器
      checkedStaffList:[], // 选择的员工
      allStaffList:[], // 所有的员工
    })
    const methods = {
      saveMustMultipleStaff:(list) => {
        pageConfig.checkedStaffList = list
        pageConfig.ShowMultipleStaff = false
      },
      //提交评论
      submitComment: function () {
        //评论
        if (pageConfig.content.length == 0) {
          Toast("评论必填")
          return
        }
        if (!pageConfig.formto_id) {
          Toast("评论节点为空")
          return
        }
        //图标id集合
        let imgIdList = []
        //附件id集合
        let fileIdList = []
        pageConfig.photoList.forEach(item => {
          imgIdList.push(item.id)
        });
        pageConfig.fileList.forEach(item => {
          fileIdList.push(item.id)
        });
        // Todo: 抄送人功能
        const param = {
          "formto_id": pageConfig.formto_id,
          "content": pageConfig.content,
          "file_id_list": fileIdList.join(),
          "img_id_list": imgIdList.join(),
          "user_list": pageConfig.checkedStaffList,
        }
        pageConfig.btnLoading = true
        AddComment(param).then(res => {
          if (res.code !== 200) {
            Toast(res.msg)
            return
          }
          Toast.success("提交成功")
          setTimeout(() => {
            emit('onclose',null)
          }, 1000);
          pageConfig.btnLoading = false
        })
      },
      //获取最新审批节点
      getCurrentStatus:function(){
        //获取最新审批人信息
        GetNewestFormto({ instanceId: pageConfig.instanceId }).then(
          (res) => {
            if (res.code !== 200) {
              Toast('获取最新审批人数据异常')
              return
            }
            //默认选中一条数据
            if(res.data.length>0)
            {
              pageConfig.formto_id = res.data[0].id
            }
          }
        )
      },
      //上传文件
      uploadFile: function (file) {
        const fileArr = []
        //多文件
        if (file.length && file.length > 1) {
          file.forEach((item) => {
            fileArr.push({base64:item.content.split(',')[1],file_name:item.file.name})
          })
        } else {
          fileArr.push({ base64: file.content.split(',')[1], file_name: file.file.name })
        }
        UploadBase64(fileArr,'wfs').then(res => {
          if (res.code !== 200) {
            file.status = 'failed';
            file.message = '上传失败';
            return
          }
          //多文件上传
          if (file.length && file.length > 1) {
            res.data.forEach(item => {
              file.forEach(ifile => {
                if (item.file_name == ifile.file.name) {
                  ifile.id = item.id;
                  return
                }
              });
            });
          } else {
            file.id = res.data[0].id
          }
        });
      }
    }
    onMounted(() => {
      ChangeTitle.setTitle("评论")
      //获取最新审批节点
      methods.getCurrentStatus()
    })
    return {
      pageConfig,
      methods
    }
  }
}
</script>
<style lang="scss">

.line{
  height: 10px;
}
.comment-block {
  padding-bottom: 80px;
  margin: 5px auto;
  position: relative;
  .lable_icon {
    color: red;
    font-size: 4px;
    transform: scale(0.65);
  }
  .upload-block {
    p {
      text-indent: 10px;
      margin: 5px 0;
      color: #898989;
    }
    .upload-photo,
    .upload-file {
      background-color: #fff;
      padding: 5px 10px;
      margin: 5px auto;
      overflow-x: auto;
      .van-uploader__wrapper {
        overflow-x: scroll;
        white-space: nowrap;
        flex-wrap: inherit;
      }
      .van-uploader__wrapper::-webkit-scrollbar {
        display: none;
      }
    }
  }

  .button-block {
    width: 100%;
    background-color: #fff;
    position: fixed;
    bottom: 0;
    height: 70px;
    .van-button {
      width: 90%;
      margin: 10px 5%;
    }
  }
}
</style>






